import axios from "axios";
import AutoRefreshToken from "../autoRefreshToken";

export default class MimiAutoRefreshToken extends AutoRefreshToken{
    _expired = 59 * 60 * 1000;

    async _requestToken(){
        const res = await axios.get('/mimi/token');
        return res.data.data.accessToken;
    }
}
